/**
 * Copernicus Marine Service (CMEMS) wave buoy stations.
 *
 * Data source: `INSITU_IBI_PHYBGCWAV_DISCRETE_MYNRT_013_033` — the
 * Iberia-Biscay-Ireland In-Situ Near-Real-Time observations product.
 * The hourly cron in `.github/workflows/cmems-pull.yml` subsets recent
 * observations from this product and writes them to the Firestore
 * `observationsCache` collection; serverless handlers read from that
 * cache rather than hitting CMEMS directly (their auth model is not
 * serverless-friendly).
 *
 * `cmemsPlatformCode` is the exact `platform_code` string the
 * `copernicusmarine` toolbox returns for that buoy, and is what the
 * pull script filters on. The display `id` is namespaced as
 * `cmems:<platform_code>` so the rest of the accuracy pipeline can
 * route by prefix.
 *
 * Platform codes confirmed against the live dataset inventory on
 * 2026-05-12 — keep this file in sync with `STATIONS` in
 * `scripts/cmems-pull.py`.
 */

export interface CMEMSStation {
  id: string;
  name: string;
  lat: number;
  lon: number;
  type: "nearshore" | "offshore";
  cmemsPlatformCode: string;
}

export const CMEMS_STATIONS: CMEMSStation[] = [
  // ── Portugal Atlantic (the regions this whole pipeline exists for) ──
  {
    id: "cmems:Leixoes-coast-buoy",
    name: "Leixões",
    lat: 41.317,
    lon: -8.733,
    type: "nearshore",
    cmemsPlatformCode: "Leixoes-coast-buoy",
  },
  {
    id: "cmems:Sines-coast-buoy",
    name: "Sines",
    lat: 37.917,
    lon: -8.917,
    type: "nearshore",
    cmemsPlatformCode: "Sines-coast-buoy",
  },
  {
    id: "cmems:Faro-coast-buoy",
    name: "Faro",
    lat: 36.92,
    lon: -7.985,
    type: "nearshore",
    cmemsPlatformCode: "Faro-coast-buoy",
  },

  // ── Bay of Biscay (Basque / Asturias surf) ──────────────────────────
  {
    id: "cmems:Bilbao-coast-buoy",
    name: "Bilbao (coast)",
    lat: 43.45,
    lon: -3.05,
    type: "nearshore",
    cmemsPlatformCode: "Bilbao-coast-buoy",
  },
  {
    id: "cmems:Bilbao-station",
    name: "Bilbao (deep)",
    lat: 43.64,
    lon: -3.05,
    type: "offshore",
    cmemsPlatformCode: "Bilbao-station",
  },
  {
    id: "cmems:Gijon-coast-buoy",
    name: "Gijón",
    lat: 43.65,
    lon: -5.62,
    type: "nearshore",
    cmemsPlatformCode: "Gijon-coast-buoy",
  },
  {
    id: "cmems:PasaiaII-coast-buoy",
    name: "Pasaia II",
    lat: 43.4,
    lon: -1.92,
    type: "nearshore",
    cmemsPlatformCode: "PasaiaII-coast-buoy",
  },
];
